import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">

                {/* LEFT BIG LOGO (BACKGROUND STYLE) */}
                <div className="footer-left">
                    <img
                        src="/images/prod-header/logo-only-vd.png"
                        alt="Background Logo"
                    />
                </div>

                {/* CENTER TEXT */}
                <div className="footer-center">
                    <a href="https://latpay.com/contact/" target="_blank" className="contact-btn">
                        CONTACT US
                    </a>
                </div>

                {/* RIGHT LOGO */}
                <div className="footer-right">
                    <img
                        src="/images/prod-header/logo-vd.png"
                        alt="Latpay"
                    />
                </div>

            </div>
        </footer>
    );
};

export default Footer;